import SubcategoryPage from '@/components/template/SubcategoryPage';

const Natur = () => {
  const products = [
    {
      title: "Natur Omarica",
      imageSrc: "https://images.unsplash.com/photo-1600566752355-35792bedcfea?auto=format&fit=crop&q=80",
      url: "/pohistvo/natur/omarica"
    },
    {
      title: "Natur Polica",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/pohistvo/natur/polica"
    },
    {
      title: "Natur Ogledalo",
      imageSrc: "https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80",
      url: "/pohistvo/natur/ogledalo"
    },
    {
      title: "Natur Komoda",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/pohistvo/natur/komoda"
    },
    {
      title: "Natur Stol",
      imageSrc: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&q=80",
      url: "/pohistvo/natur/stol"
    },
    {
      title: "Natur Set",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/pohistvo/natur/set"
    }
  ];

  return (
    <SubcategoryPage
      title="Kolekcija Natur"
      description="Raziščite našo naravno kolekcijo pohištva, ki prinaša toplino in organsko lepoto v vaš dom. Izdelki iz naravnih materialov za trajnostno in pristno bivalno izkušnjo."
      heroImage="https://images.unsplash.com/photo-1600566752355-35792bedcfea?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Natur;